module.exports = __webpack_public_path__ + "img/AMZ123.c59b4442.jpg";